import { Link } from "react-router-dom";
import { useContext } from "react";
import { CartContext } from "../context/CartContext";
import logo from "../assets/Pace.jpg";
import "./Navbar.css";

const Navbar = ({ search, setSearch }) => {
  const { cart } = useContext(CartContext) || { cart: [] };

  const totalItems = cart.length;

  return (
    <nav className="navbar">

      {/* LEFT: LOGO */}
      <Link to="/" className="brand">
        <img src={logo} alt="logo" className="logo-img" />

        <div className="brand-name">
          <span className="main-name">PACE SERVICE AFFAIRS Ltd</span>
          <span className="sub-name">(Worobo Market)</span>
        </div>
      </Link>

      {/* CENTER: SEARCH (CONTROLLED FROM APP.JS) */}
      <div className="search-box">
        <input
          type="text"
          placeholder="Search foodstuff..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* CART */}
      <Link to="/cart" className="cart">
        🛒 <span>{totalItems}</span>
      </Link>

    </nav>
  );
};

export default Navbar;